export default __webpack_public_path__ + "static/media/aim.12500a65.png";